import { useContext, useEffect } from "react";
import AppContext from "src/app/AppContext";
import { DEFAULT_VISITOR_CONTEXT } from "src/trackers/viewerContext";

// Pub-less pages share this trigger; the portal's "gaEvent" logs as "pdf portal".
// Pass pageName where document.title does not identify the page ("ePaper" on 9 routes).
export default function useCommonPageView(pageName?: string): void {
  const { visitorContext } = useContext(AppContext);

  useEffect(() => {
    const visitor = visitorContext ?? DEFAULT_VISITOR_CONTEXT;
    const w = window as unknown as Window & {
      dataLayer?: Record<string, unknown>[];
    };
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({
      event: "page_view",
      event_details: {
        pageName: pageName ?? document.title,
        visitorCategory: visitor.visitorCategory,
        visitorId: visitor.visitorId,
        svc: visitor.svc,
      },
    });
  }, []);
}
